import React, { useContext } from 'react';
const PageContext = React.createContext({});
function usePageContext() {
    return useContext(PageContext);
}
export { PageContext, usePageContext };
// Allows storybook to get props
export const PageContextPropsDoc = () => null;
export const PageBackNavigationPropsDoc = () => null;
